import { useCallback, useContext } from 'react'
import { ConfigContext } from '../store/ConfigContext'
import { ContentStackTypes } from '../store/Constants'

const HAS_CONFIGURATION_DEFINITION = '[[HAS_CONFIGURATION_DEFINITIONS]]'
const CONFIGURATION_DEFINITION_KEY_PLACEHOLDER = '[[CONFIGURATION_DEFINITIONS('
export const useConfigurationDefinitions = () => {
  const { cachedCMS } = useContext(ConfigContext)

  const findConfigurationDefinitions = useCallback(
    (configurationKey) => {
      const configurationValue = cachedCMS
        ?.get(ContentStackTypes.configuration_definitions.content_type_uid)
        ?.definitions.find(
          (definition) =>
            definition.configuration_key.toUpperCase() ===
            configurationKey.toUpperCase()
        )?.configuration_value
      if (configurationValue) {
        return JSON.parse(configurationValue)
      }
      return null
    },
    [cachedCMS]
  )

  const replaceStringWithConfigurationDefinition = (
    content,
    configurationKey,
    configurationValue
  ) => {
    return configurationValue
      ? content.replace(
          `${CONFIGURATION_DEFINITION_KEY_PLACEHOLDER}${configurationKey})]]`,
          configurationValue
        )
      : configurationKey
  }

  const getConfigurationDefinitionKey = (content) => {
    if (content.indexOf(CONFIGURATION_DEFINITION_KEY_PLACEHOLDER) === -1) {
      return null
    }
    return content
      .split(CONFIGURATION_DEFINITION_KEY_PLACEHOLDER)[1]
      .split(')]]')[0]
  }

  const replaceContentWithConfigurationDefinition = (content) => {
    if (!content.startsWith(HAS_CONFIGURATION_DEFINITION)) {
      return content
    }
    let configurationKey = getConfigurationDefinitionKey(content)
    let finalContent = content.replace(HAS_CONFIGURATION_DEFINITION, '')
    while (configurationKey) {
      const [rootkey, ...nestedKeys] = configurationKey.split('.')
      const configurationDefinition = findConfigurationDefinitions(rootkey)

      let configurationValue = null
      if (configurationDefinition && nestedKeys.length > 0) {
        configurationValue = configurationDefinition
        for (const key of nestedKeys) {
          if (
            configurationValue &&
            Object.prototype.hasOwnProperty.call(configurationValue, key)
          ) {
            configurationValue = configurationValue[key]
          } else {
            configurationValue = null
            break
          }
        }
      }
      finalContent = replaceStringWithConfigurationDefinition(
        finalContent,
        configurationKey,
        configurationValue?.toString()
      )
      configurationKey = getConfigurationDefinitionKey(finalContent)
    }
    return finalContent
  }

  return {
    findConfigurationDefinitions,
    replaceContentWithConfigurationDefinition
  }
}
